"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _MaterialStandardData_attenuationColor, _MaterialStandardData_attenuationDistance, _MaterialStandardData_clearcoat, _MaterialStandardData_clearcoatMap, _MaterialStandardData_clearcoatNormalMap, _MaterialStandardData_clearcoatRoughness, _MaterialStandardData_clearcoatRoughnessMap, _MaterialStandardData_displacementMap, _MaterialStandardData_displacementScale, _MaterialStandardData_displacementBias, _MaterialStandardData_envMap, _MaterialStandardData_ior, _MaterialStandardData_metalness, _MaterialStandardData_metalnessMap, _MaterialStandardData_metalnessRoughnessMap, _MaterialStandardData_roughness, _MaterialStandardData_roughnessMap, _MaterialStandardData_sheen, _MaterialStandardData_sheenColor, _MaterialStandardData_sheenColorMap, _MaterialStandardData_sheenRoughness, _MaterialStandardData_sheenRoughnessMap, _MaterialStandardData_specularColor, _MaterialStandardData_specularColorMap, _MaterialStandardData_specularIntensity, _MaterialStandardData_specularIntensityMap, _MaterialStandardData_thickness, _MaterialStandardData_thicknessMap, _MaterialStandardData_transmission, _MaterialStandardData_transmissionMap;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialStandardData = void 0;
const viewer_shared_types_1 = require("@shapediver/viewer.shared.types");
const AbstractMaterialData_1 = require("./AbstractMaterialData");
class MaterialStandardData extends AbstractMaterialData_1.AbstractMaterialData {
    // #endregion Properties (26)
    // #region Constructors (1)
    /**
     * Creates a material data object.
     *
     * @param _attributes the attributes of the material
     * @param id the id
     */
    constructor(properties, id, version) {
        super(properties, id, version);
        // #region Properties (26)
        _MaterialStandardData_attenuationColor.set(this, "#ffffff");
        _MaterialStandardData_attenuationDistance.set(this, Infinity);
        _MaterialStandardData_clearcoat.set(this, 0);
        _MaterialStandardData_clearcoatMap.set(this, void 0);
        _MaterialStandardData_clearcoatNormalMap.set(this, void 0);
        _MaterialStandardData_clearcoatRoughness.set(this, 0);
        _MaterialStandardData_clearcoatRoughnessMap.set(this, void 0);
        _MaterialStandardData_displacementMap.set(this, void 0);
        _MaterialStandardData_displacementScale.set(this, 1);
        _MaterialStandardData_displacementBias.set(this, 0);
        _MaterialStandardData_envMap.set(this, void 0);
        _MaterialStandardData_ior.set(this, 1.5);
        _MaterialStandardData_metalness.set(this, 1.0);
        _MaterialStandardData_metalnessMap.set(this, void 0);
        _MaterialStandardData_metalnessRoughnessMap.set(this, void 0);
        _MaterialStandardData_roughness.set(this, 1.0);
        _MaterialStandardData_roughnessMap.set(this, void 0);
        _MaterialStandardData_sheen.set(this, 0.0);
        _MaterialStandardData_sheenColor.set(this, "#ffffff");
        _MaterialStandardData_sheenColorMap.set(this, void 0);
        _MaterialStandardData_sheenRoughness.set(this, 1.0);
        _MaterialStandardData_sheenRoughnessMap.set(this, void 0);
        _MaterialStandardData_specularColor.set(this, "#ffffff");
        _MaterialStandardData_specularColorMap.set(this, void 0);
        _MaterialStandardData_specularIntensity.set(this, 1.0);
        _MaterialStandardData_specularIntensityMap.set(this, void 0);
        _MaterialStandardData_thickness.set(this, 0.0);
        _MaterialStandardData_thicknessMap.set(this, void 0);
        _MaterialStandardData_transmission.set(this, 0.0);
        _MaterialStandardData_transmissionMap.set(this, void 0);
        if (!properties)
            return;
        if (properties.metalness !== undefined)
            this.metalness = properties.metalness;
        if (properties.metalnessMap !== undefined)
            this.metalnessMap = properties.metalnessMap;
        if (properties.metalnessRoughnessMap !== undefined)
            this.metalnessRoughnessMap = properties.metalnessRoughnessMap;
        if (properties.roughness !== undefined)
            this.roughness = properties.roughness;
        if (properties.roughnessMap !== undefined)
            this.roughnessMap = properties.roughnessMap;
        if (properties.clearcoat !== undefined)
            this.clearcoat = properties.clearcoat;
        if (properties.clearcoatMap !== undefined)
            this.clearcoatMap = properties.clearcoatMap;
        if (properties.clearcoatNormalMap !== undefined)
            this.clearcoatNormalMap = properties.clearcoatNormalMap;
        if (properties.clearcoatRoughness !== undefined)
            this.clearcoatRoughness = properties.clearcoatRoughness;
        if (properties.clearcoatRoughnessMap !== undefined)
            this.clearcoatRoughnessMap = properties.clearcoatRoughnessMap;
        if (properties.displacementMap !== undefined)
            this.displacementMap = properties.displacementMap;
        if (properties.displacementScale !== undefined)
            this.displacementScale = properties.displacementScale;
        if (properties.displacementBias !== undefined)
            this.displacementBias = properties.displacementBias;
        if (properties.ior !== undefined)
            this.ior = properties.ior;
        if (properties.transmission !== undefined)
            this.transmission = properties.transmission;
        if (properties.transmissionMap !== undefined)
            this.transmissionMap = properties.transmissionMap;
        if (properties.thickness !== undefined)
            this.thickness = properties.thickness;
        if (properties.thicknessMap !== undefined)
            this.thicknessMap = properties.thicknessMap;
        if (properties.attenuationDistance !== undefined)
            this.attenuationDistance = properties.attenuationDistance;
        if (properties.attenuationColor !== undefined)
            this.attenuationColor = properties.attenuationColor;
        if (properties.sheen !== undefined)
            this.sheen = properties.sheen;
        if (properties.sheenColor !== undefined)
            this.sheenColor = properties.sheenColor;
        if (properties.sheenRoughness !== undefined)
            this.sheenRoughness = properties.sheenRoughness;
        if (properties.sheenColorMap !== undefined)
            this.sheenColorMap = properties.sheenColorMap;
        if (properties.sheenRoughnessMap !== undefined)
            this.sheenRoughnessMap = properties.sheenRoughnessMap;
        if (properties.specularColor !== undefined)
            this.specularColor = properties.specularColor;
        if (properties.specularColorMap !== undefined)
            this.specularColorMap = properties.specularColorMap;
        if (properties.specularIntensity !== undefined)
            this.specularIntensity = properties.specularIntensity;
        if (properties.specularIntensityMap !== undefined)
            this.specularIntensityMap = properties.specularIntensityMap;
        if (properties.envMap !== undefined)
            this.envMap = properties.envMap;
    }
    // #endregion Constructors (1)
    // #region Public Accessors (52)
    get attenuationColor() {
        return __classPrivateFieldGet(this, _MaterialStandardData_attenuationColor, "f");
    }
    set attenuationColor(value) {
        __classPrivateFieldSet(this, _MaterialStandardData_attenuationColor, value, "f");
    }
    get attenuationDistance() {
        return __classPrivateFieldGet(this, _MaterialStandardData_attenuationDistance, "f");
    }
    set attenuationDistance(value) {
        __classPrivateFieldSet(this, _MaterialStandardData_attenuationDistance, value, "f");
    }
    get clearcoat() {
        return __classPrivateFieldGet(this, _MaterialStandardData_clearcoat, "f");
    }
    set clearcoat(value) {
        __classPrivateFieldSet(this, _MaterialStandardData_clearcoat, value, "f");
    }
    get clearcoatMap() {
        return __classPrivateFieldGet(this, _MaterialStandardData_clearcoatMap, "f");
    }
    set clearcoatMap(value) {
        __classPrivateFieldSet(this, _MaterialStandardData_clearcoatMap, value, "f");
    }
    get clearcoatNormalMap() {
        return __classPrivateFieldGet(this, _MaterialStandardData_clearcoatNormalMap, "f");
    }
    set clearcoatNormalMap(value) {
        __classPrivateFieldSet(this, _MaterialStandardData_clearcoatNormalMap, value, "f");
    }
    get clearcoatRoughness() {
        return __classPrivateFieldGet(this, _MaterialStandardData_clearcoatRoughness, "f");
    }
    set clearcoatRoughness(value) {
        __classPrivateFieldSet(this, _MaterialStandardData_clearcoatRoughness, value, "f");
    }
    get clearcoatRoughnessMap() {
        return __classPrivateFieldGet(this, _MaterialStandardData_clearcoatRoughnessMap, "f");
    }
    set clearcoatRoughnessMap(value) {
        __classPrivateFieldSet(this, _MaterialStandardData_clearcoatRoughnessMap, value, "f");
    }
    get displacementMap() {
        return __classPrivateFieldGet(this, _MaterialStandardData_displacementMap, "f");
    }
    set displacementMap(value) {
        __classPrivateFieldSet(this, _MaterialStandardData_displacementMap, value, "f");
    }
    get displacementScale() {
        return __classPrivateFieldGet(this, _MaterialStandardData_displacementScale, "f");
    }
    set displacementScale(value) {
        __classPrivateFieldSet(this, _MaterialStandardData_displacementScale, value, "f");
    }
    get displacementBias() {
        return __classPrivateFieldGet(this, _MaterialStandardData_displacementBias, "f");
    }
    set displacementBias(value) {
        __classPrivateFieldSet(this, _MaterialStandardData_displacementBias, value, "f");
    }
    get envMap() {
        return __classPrivateFieldGet(this, _MaterialStandardData_envMap, "f");
    }
    set envMap(value) {
        __classPrivateFieldSet(this, _MaterialStandardData_envMap, value, "f");
    }
    get ior() {
        return __classPrivateFieldGet(this, _MaterialStandardData_ior, "f");
    }
    set ior(value) {
        __classPrivateFieldSet(this, _MaterialStandardData_ior, value, "f");
    }
    get metalness() {
        return __classPrivateFieldGet(this, _MaterialStandardData_metalness, "f");
    }
    set metalness(value) {
        __classPrivateFieldSet(this, _MaterialStandardData_metalness, value, "f");
    }
    get metalnessMap() {
        return __classPrivateFieldGet(this, _MaterialStandardData_metalnessMap, "f");
    }
    set metalnessMap(value) {
        __classPrivateFieldSet(this, _MaterialStandardData_metalnessMap, value, "f");
    }
    get metalnessRoughnessMap() {
        return __classPrivateFieldGet(this, _MaterialStandardData_metalnessRoughnessMap, "f");
    }
    set metalnessRoughnessMap(value) {
        __classPrivateFieldSet(this, _MaterialStandardData_metalnessRoughnessMap, value, "f");
    }
    get roughness() {
        return __classPrivateFieldGet(this, _MaterialStandardData_roughness, "f");
    }
    set roughness(value) {
        __classPrivateFieldSet(this, _MaterialStandardData_roughness, value, "f");
    }
    get roughnessMap() {
        return __classPrivateFieldGet(this, _MaterialStandardData_roughnessMap, "f");
    }
    set roughnessMap(value) {
        __classPrivateFieldSet(this, _MaterialStandardData_roughnessMap, value, "f");
    }
    get sheen() {
        return __classPrivateFieldGet(this, _MaterialStandardData_sheen, "f");
    }
    set sheen(value) {
        __classPrivateFieldSet(this, _MaterialStandardData_sheen, value, "f");
    }
    get sheenColor() {
        return __classPrivateFieldGet(this, _MaterialStandardData_sheenColor, "f");
    }
    set sheenColor(value) {
        __classPrivateFieldSet(this, _MaterialStandardData_sheenColor, value, "f");
    }
    get sheenColorMap() {
        return __classPrivateFieldGet(this, _MaterialStandardData_sheenColorMap, "f");
    }
    set sheenColorMap(value) {
        __classPrivateFieldSet(this, _MaterialStandardData_sheenColorMap, value, "f");
    }
    get sheenRoughness() {
        return __classPrivateFieldGet(this, _MaterialStandardData_sheenRoughness, "f");
    }
    set sheenRoughness(value) {
        __classPrivateFieldSet(this, _MaterialStandardData_sheenRoughness, value, "f");
    }
    get sheenRoughnessMap() {
        return __classPrivateFieldGet(this, _MaterialStandardData_sheenRoughnessMap, "f");
    }
    set sheenRoughnessMap(value) {
        __classPrivateFieldSet(this, _MaterialStandardData_sheenRoughnessMap, value, "f");
    }
    get specularColor() {
        return __classPrivateFieldGet(this, _MaterialStandardData_specularColor, "f");
    }
    set specularColor(value) {
        __classPrivateFieldSet(this, _MaterialStandardData_specularColor, value, "f");
    }
    get specularColorMap() {
        return __classPrivateFieldGet(this, _MaterialStandardData_specularColorMap, "f");
    }
    set specularColorMap(value) {
        __classPrivateFieldSet(this, _MaterialStandardData_specularColorMap, value, "f");
    }
    get specularIntensity() {
        return __classPrivateFieldGet(this, _MaterialStandardData_specularIntensity, "f");
    }
    set specularIntensity(value) {
        __classPrivateFieldSet(this, _MaterialStandardData_specularIntensity, value, "f");
    }
    get specularIntensityMap() {
        return __classPrivateFieldGet(this, _MaterialStandardData_specularIntensityMap, "f");
    }
    set specularIntensityMap(value) {
        __classPrivateFieldSet(this, _MaterialStandardData_specularIntensityMap, value, "f");
    }
    get thickness() {
        return __classPrivateFieldGet(this, _MaterialStandardData_thickness, "f");
    }
    set thickness(value) {
        __classPrivateFieldSet(this, _MaterialStandardData_thickness, value, "f");
    }
    get thicknessMap() {
        return __classPrivateFieldGet(this, _MaterialStandardData_thicknessMap, "f");
    }
    set thicknessMap(value) {
        __classPrivateFieldSet(this, _MaterialStandardData_thicknessMap, value, "f");
    }
    get transmission() {
        return __classPrivateFieldGet(this, _MaterialStandardData_transmission, "f");
    }
    set transmission(value) {
        __classPrivateFieldSet(this, _MaterialStandardData_transmission, value, "f");
    }
    get transmissionMap() {
        return __classPrivateFieldGet(this, _MaterialStandardData_transmissionMap, "f");
    }
    set transmissionMap(value) {
        __classPrivateFieldSet(this, _MaterialStandardData_transmissionMap, value, "f");
    }
    // #endregion Public Accessors (52)
    // #region Public Methods (1)
    reset() {
        this.alphaCutoff = 0;
        this.alphaMap = undefined;
        this.alphaMode = viewer_shared_types_1.MATERIAL_ALPHA.OPAQUE;
        this.aoMap = undefined;
        this.aoMapIntensity = 1.0;
        this.bumpMap = undefined;
        this.bumpScale = 1.0;
        this.color = "#ffffff";
        this.depthTest = undefined;
        this.depthWrite = undefined;
        this.emissiveMap = undefined;
        this.emissiveness = "#000000";
        this.materialOutput = false;
        this.map = undefined;
        this.normalMap = undefined;
        this.normalScale = 1.0;
        this.opacity = 1.0;
        this.shading = viewer_shared_types_1.MATERIAL_SHADING.SMOOTH;
        this.side = viewer_shared_types_1.MATERIAL_SIDE.DOUBLE;
        this.transparent = undefined;
        this.attenuationColor = "#ffffff";
        this.attenuationDistance = Infinity;
        this.clearcoat = 0;
        this.clearcoatMap = undefined;
        this.clearcoatNormalMap = undefined;
        this.clearcoatRoughness = 0;
        this.clearcoatRoughnessMap = undefined;
        this.displacementMap = undefined;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.envMap = undefined;
        this.ior = 1;
        this.metalness = 0;
        this.metalnessMap = undefined;
        this.metalnessRoughnessMap = undefined;
        this.roughness = 0.5;
        this.roughnessMap = undefined;
        this.sheen = 0;
        this.sheenColor = "#ffffff";
        this.sheenColorMap = undefined;
        this.sheenRoughness = 0;
        this.sheenRoughnessMap = undefined;
        this.specularColor = "#ffffff";
        this.specularColorMap = undefined;
        this.specularIntensity = 1;
        this.specularIntensityMap = undefined;
        this.thickness = 0.1;
        this.thicknessMap = undefined;
        this.transmission = 0;
        this.transmissionMap = undefined;
    }
    clone() {
        return new MaterialStandardData({
            alphaMap: this.alphaMap,
            alphaCutoff: this.alphaCutoff,
            alphaMode: this.alphaMode,
            aoMap: this.aoMap,
            aoMapIntensity: this.aoMapIntensity,
            bumpMap: this.bumpMap,
            bumpScale: this.bumpScale,
            color: this.color,
            depthTest: this.depthTest,
            depthWrite: this.depthWrite,
            emissiveMap: this.emissiveMap,
            emissiveness: this.emissiveness,
            shading: this.shading,
            map: this.map,
            metalness: this.metalness,
            metalnessMap: this.metalnessMap,
            metalnessRoughnessMap: this.metalnessRoughnessMap,
            name: this.name,
            normalMap: this.normalMap,
            normalScale: this.normalScale,
            opacity: this.opacity,
            roughness: this.roughness,
            roughnessMap: this.roughnessMap,
            side: this.side,
            transparent: this.transparent,
            clearcoat: this.clearcoat,
            clearcoatMap: this.clearcoatMap,
            clearcoatNormalMap: this.clearcoatNormalMap,
            clearcoatRoughness: this.clearcoatRoughness,
            clearcoatRoughnessMap: this.clearcoatRoughnessMap,
            displacementMap: this.displacementMap,
            displacementScale: this.displacementScale,
            displacementBias: this.displacementBias,
            envMap: this.envMap,
            ior: this.ior,
            transmission: this.transmission,
            transmissionMap: this.transmissionMap,
            thickness: this.thickness,
            thicknessMap: this.thicknessMap,
            attenuationDistance: this.attenuationDistance,
            attenuationColor: this.attenuationColor,
            sheen: this.sheen,
            sheenColor: this.sheenColor,
            sheenColorMap: this.sheenColorMap,
            sheenRoughness: this.sheenRoughness,
            sheenRoughnessMap: this.sheenRoughnessMap,
            specularColor: this.specularColor,
            specularColorMap: this.specularColorMap,
            specularIntensity: this.specularIntensity,
            specularIntensityMap: this.specularIntensityMap,
        }, this.id, this.version);
    }
    copy(source) {
        this.alphaCutoff = source.alphaCutoff;
        this.alphaMap = source.alphaMap;
        this.alphaMode = source.alphaMode;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.color = source.color;
        this.depthTest = source.depthTest;
        this.depthWrite = source.depthWrite;
        this.emissiveMap = source.emissiveMap;
        this.emissiveness = source.emissiveness;
        this.materialOutput = source.materialOutput;
        this.map = source.map;
        this.normalMap = source.normalMap;
        this.normalScale = source.normalScale;
        this.opacity = source.opacity;
        this.shading = source.shading;
        this.side = source.side;
        this.transparent = source.transparent;
        this.attenuationColor = source.attenuationColor;
        this.attenuationDistance = source.attenuationDistance;
        this.clearcoat = source.clearcoat;
        this.clearcoatMap = source.clearcoatMap;
        this.clearcoatNormalMap = source.clearcoatNormalMap;
        this.clearcoatRoughness = source.clearcoatRoughness;
        this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.envMap = source.envMap;
        this.ior = source.ior;
        this.metalness = source.metalness;
        this.metalnessMap = source.metalnessMap;
        this.metalnessRoughnessMap = source.metalnessRoughnessMap;
        this.roughness = source.roughness;
        this.roughnessMap = source.roughnessMap;
        this.sheen = source.sheen;
        this.sheenColor = source.sheenColor;
        this.sheenColorMap = source.sheenColorMap;
        this.sheenRoughness = source.sheenRoughness;
        this.sheenRoughnessMap = source.sheenRoughnessMap;
        this.specularColor = source.specularColor;
        this.specularColorMap = source.specularColorMap;
        this.specularIntensity = source.specularIntensity;
        this.specularIntensityMap = source.specularIntensityMap;
        this.thickness = source.thickness;
        this.thicknessMap = source.thicknessMap;
        this.transmission = source.transmission;
        this.transmissionMap = source.transmissionMap;
    }
}
exports.MaterialStandardData = MaterialStandardData;
_MaterialStandardData_attenuationColor = new WeakMap(), _MaterialStandardData_attenuationDistance = new WeakMap(), _MaterialStandardData_clearcoat = new WeakMap(), _MaterialStandardData_clearcoatMap = new WeakMap(), _MaterialStandardData_clearcoatNormalMap = new WeakMap(), _MaterialStandardData_clearcoatRoughness = new WeakMap(), _MaterialStandardData_clearcoatRoughnessMap = new WeakMap(), _MaterialStandardData_displacementMap = new WeakMap(), _MaterialStandardData_displacementScale = new WeakMap(), _MaterialStandardData_displacementBias = new WeakMap(), _MaterialStandardData_envMap = new WeakMap(), _MaterialStandardData_ior = new WeakMap(), _MaterialStandardData_metalness = new WeakMap(), _MaterialStandardData_metalnessMap = new WeakMap(), _MaterialStandardData_metalnessRoughnessMap = new WeakMap(), _MaterialStandardData_roughness = new WeakMap(), _MaterialStandardData_roughnessMap = new WeakMap(), _MaterialStandardData_sheen = new WeakMap(), _MaterialStandardData_sheenColor = new WeakMap(), _MaterialStandardData_sheenColorMap = new WeakMap(), _MaterialStandardData_sheenRoughness = new WeakMap(), _MaterialStandardData_sheenRoughnessMap = new WeakMap(), _MaterialStandardData_specularColor = new WeakMap(), _MaterialStandardData_specularColorMap = new WeakMap(), _MaterialStandardData_specularIntensity = new WeakMap(), _MaterialStandardData_specularIntensityMap = new WeakMap(), _MaterialStandardData_thickness = new WeakMap(), _MaterialStandardData_thicknessMap = new WeakMap(), _MaterialStandardData_transmission = new WeakMap(), _MaterialStandardData_transmissionMap = new WeakMap();
//# sourceMappingURL=MaterialStandardData.js.map